import { Box } from '@material-ui/core'
import { FunctionComponent } from 'react'
import { Modal } from 'components/core/modal'
import { bfutr2023palette } from '../bfutr2023palette'
import { Bfutr2023TicketConfirmationDetails } from '../Bfutr2023TicketConfirmationDetails'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'

interface Bfutr2023TicketConfirmationModalProps {
  show: boolean
  onClose: Function
}

export const Bfutr2023TicketConfirmationModal: FunctionComponent<Bfutr2023TicketConfirmationModalProps> = ({
  show,
  onClose
}) => {
  const { isDevice } = useScreenSizes()
  return (
    <Modal 
      showCancel 
      show={show} 
      onClose={onClose} 
      title="" 
      noBorder 
      dialogWidth="sm"
      backgroundColor={bfutr2023palette.backgroundColor}
      borderRadius='15px'
      isSummit
    >
      <Box width="100%" padding='0 1em 1em 1em'>
        <Box display="flex" justifyContent="center" marginBottom="1em">
          <img
            src="https://bptn-frontend-music-dev.s3.amazonaws.com/media/images/logos/emails/bfutr2023_banner.png"
            style={{ borderRadius: '10px', height: '10em', width: '100%', objectFit: 'cover', position:'relative' }}
            alt="summit event banner"
          />
        </Box>
        <Bfutr2023TicketConfirmationDetails isDevice={isDevice} onClose={onClose}/>
      </Box>
    </Modal>
  )
}
